import Close from "../assets/img/Cancel.svg";
import { useState, useEffect } from "react";
import styled from "styled-components";
import WheelPicker from "./WheelPicker";
import FaqRadio from "./FaqRadio";

const StyledModalBackground = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.5;
  z-index: 2;
`;

const StyledBottomSheet = styled.div`
  z-index: 3;
  position: fixed;
  width: 100%;
  height: fit-content;
  max-height: 90%;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  bottom: 0;
  left: 0;
  border-radius: 1rem 1rem 0 0;
  background-color: rgba(51, 51, 51, 1);
`;

const StyledBottomSheetHeader = styled.div`
  height: 55px;
  padding: 1.1rem 2.2rem 0.9rem 2.2rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(102, 102, 102, 1);
  position: sticky;
  top: 0;
  background: rgba(51, 51, 51, 1);

  & > img {
    cursor: pointer;
  }

  & > div {
    font-weight: 500;
    font-size: 14px;
    line-height: 1.7rem;
    color: rgba(0, 200, 140, 1);
    position: absolute;
  }

  & > .title {
    left: 50%;
    color: rgba(230, 230, 230, 1);
    transform: translateX(-50%);
    font-size: 18px;
  }

  & > .aos_title {
    left: 4%;
    color: rgba(230, 230, 230, 1);
    font-size: 18px;
  }

  & > .cancle {
    left: 5%;
  }
  & > .ok {
    right: 5%;
  }
  & > .aos_close {
    right: 3%;
  }
`;

function BottomSheet({ title, closeModal, children, onSelect }) {
  /**모바일 기종 분기처리 (ios, 안드로이드, 그 외) */
  const [phoneType, setPhoneType] = useState();
  function checkMobile() {
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    if (varUA.indexOf("android") > -1) {
      //안드로이드
      setPhoneType("android");
      return "android";
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
    ) {
      //IOS
      setPhoneType("ios");
      return "ios";
    } else {
      //아이폰, 안드로이드 외
      setPhoneType("other");
      return "other";
    }
  }
  useEffect(() => {
    checkMobile();
  }, []);
  const [select, setSelect] = useState();


  const onSelectHandler = (selected) => {
    setSelect(selected);
  };

  const onOk = () => {
    onSelect(select);
    closeModal();
  };
  const onSelectAos = (selected) => {
    onSelect(selected);
    if (selected) {
      setTimeout(function () {
        closeModal();
      }, 200);
    }
  };

  return (
    <>
      <StyledModalBackground />
      <StyledBottomSheet>
        <StyledBottomSheetHeader>
          {phoneType === "ios" ? (
            <div className="cancle" onClick={closeModal}>
              취소
            </div>
          ) : null}
          <div className={phoneType === "ios" ? "title" : "aos_title"}>
            {title}
          </div>
          {phoneType !== "ios" ? (
            <div className="aos_close" onClick={closeModal}>
              <img src={Close} alt="닫기" />
            </div>
          ) : null}

          {phoneType === "ios" ? (
            <div className="ok" onClick={onOk}>
              확인
            </div>
          ) : null}
        </StyledBottomSheetHeader>
        {phoneType === "ios" ? (
          <WheelPicker onSelect={onSelectHandler} />
        ) : (
          <div className="select_item_wrap">
            <FaqRadio onSelect={onSelectAos} />
          </div>
        )}
      </StyledBottomSheet>
    </>
  );
}

export default BottomSheet;
